import React from "react";
import { Translate } from "react-redux-i18n";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import "./styles/BlogCarousel.css";

const TESTIMONIALS = [
  {
    name: "Juan C. Rendon",
    content: "Realice la compra, contacte al vendedor, negociamos y recibi el articulo sin novedad.",
    porcent: 85,
  },
  {
    name: "John Guzman",
    content: "Buen vendedor, buena plataforma gracias",
    porcent: 70,
  },
  {
    name: "Maria Zapata",
    content: "me llego el producto bien, sin novedad",
    porcent: 95,
  },
  {
    name: "Carlos Guaman",
    content: "Vendedor muy muy confiable .",
    porcent: 90,
  },
  {
    name: "Mery Garcia",
    content: "Gracias a Dios, todo bien ",
    porcent: 70,
  },
  {
    name: "Zaila Merino F",
    content: "Me arrepenti de hacer la compra.",
    porcent: 60,
  },
];

function getInitials(name) {
  return name
    .split(" ")
    .map((part) => part.charAt(0))
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

function renderStars(percent) {
  return Array.from({ length: 5 }, (_, index) => {
    const threshold = index * 20;

    if (percent >= threshold + 20) {
      return <FaStar key={index} className="blogcarousel-star blogcarousel-star--full" aria-hidden="true" />;
    }

    if (percent >= threshold + 10) {
      return <FaStarHalfAlt key={index} className="blogcarousel-star blogcarousel-star--half" aria-hidden="true" />;
    }

    return <FaRegStar key={index} className="blogcarousel-star blogcarousel-star--empty" aria-hidden="true" />;
  });
}

function BlogCarouselItem({ name, content, porcent }) {
  return (
    <article className="blogcarousel-card">
      <div className="blogcarousel-card__avatar" aria-hidden="true">
        {getInitials(name)}
      </div>
      <div className="blogcarousel-card__stars" aria-label={`${Math.round(porcent / 20)}/5`}>
        {renderStars(porcent)}
      </div>
      <blockquote className="blogcarousel-card__quote">"{content}"</blockquote>
      <footer className="blogcarousel-card__author">{name}</footer>
    </article>
  );
}

class BlogCarousel extends React.Component {
  state = {
    displayIndices: [0, 1, 2],
  };

  componentDidMount() {
    const start = Math.floor(Math.random() * TESTIMONIALS.length);
    const second = (start + 1) % TESTIMONIALS.length;
    const third = (second + 1) % TESTIMONIALS.length;

    this.setState({ displayIndices: [start, second, third] });
  }

  render() {
    const { displayIndices } = this.state;

    return (
      <section className="blogcarousel-section">
        <div className="blogcarousel-section__overlay" aria-hidden="true" />
        <div className="blogcarousel-section__inner">
          <header className="blogcarousel-section__header">
            <h2 className="blogcarousel-section__title">
              <Translate value="comments" />
            </h2>
            <p className="blogcarousel-section__subtitle">
              <Translate value="feedback_subtitle" />
            </p>
          </header>

          <div className="blogcarousel-grid">
            {displayIndices.map((index) => {
              const item = TESTIMONIALS[index];

              return (
                <BlogCarouselItem
                  key={`${item.name}-${index}`}
                  name={item.name}
                  content={item.content}
                  porcent={item.porcent}
                />
              );
            })}
          </div>
        </div>
      </section>
    );
  }
}

export default BlogCarousel;
